import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdBalloonOfferTypes } from "../../constants/IdBalloonOfferTypes";
import { IdStyles } from "../../less/IdStyles";
import { selectBalloonRemainingTime } from "../../selectors/selectBalloonInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { utilPackage } from "../../utils/utilPackage";
import { utilPager } from "../../utils/utilPager";
import { ButtonDefault } from "../generic/button-buy/ButtonDefault";
import { ButtonPagerLeft } from "../generic/common/ButtonPagerLeft";
import { ButtonPagerRight } from "../generic/common/ButtonPagerRight";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonSecondary } from "../generic/common/ButtonSecondary";
import { getResourceIconById } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { List } from "../generic/list/List";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { Pager } from "../generic/pager/Pager";
import { TextLoca } from "../generic/text/TextLoca";
import { actionBalloonOfferByWithGold } from "../info/balloon/actionBalloonInfo";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { ProfilePicture } from "../player-profile/ProfilePicture";
import { BalloonOfferDetailsContainer } from "./BalloonOfferDetailsContainer";
export var _BalloonOfferDetails = function (_a) {
    var balloonOfferContent = _a.balloonOfferContent, balloonOfferLevelType = _a.balloonOfferLevelType, remainingTime = _a.remainingTime, onClose = _a.onClose, onConsume = _a.onConsume;
    if (balloonOfferContent == undefined || balloonOfferLevelType == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var rewardsPerPage = 3;
    var rewards = utilPackage.balloonRewardToGameItems(balloonOfferLevelType);
    var pageCount = Math.ceil(rewards.length / rewardsPerPage);
    var renderPagerItem = function (reward, index) {
        return (React.createElement("div", { className: "reward-dialog__rewards-item", key: index },
            reward.resource && (React.createElement(ResourceIcon, { resource: reward.resource, styleId: IdStyles.IconLarge })),
            reward.profilePicture && (React.createElement(ProfilePicture, { profilePictureSize: IdStyles.ProfilePictureSmall, profilePictureName: reward.profilePicture.src })),
            React.createElement("div", { className: IdStyles.TextBoldAccent },
                React.createElement(NumberFormat, { amount: reward.amount || Long.ZERO }))));
    };
    var renderPager = function (page, changePage) {
        var renderPagerButtons = pageCount > 1;
        var slicedItems = utilPager.getPageItemsFilled(rewards, page, rewardsPerPage);
        return (React.createElement("div", { className: "level-up__rewards " + IdStyles.RewardDialogRewards },
            renderPagerButtons && React.createElement(ButtonPagerLeft, { onClick: function () { return changePage(page - 1); } }),
            React.createElement(List, { className: "flex flex__full flex--around", items: slicedItems, renderItem: renderPagerItem }),
            renderPagerButtons && React.createElement(ButtonPagerRight, { onClick: function () { return changePage(page + 1); } })));
    };
    var button = getOfferButton(balloonOfferContent, balloonOfferLevelType, function () {
        return onConsume(balloonOfferContent.id);
    });
    return (React.createElement(BalloonOfferDetailsContainer, { onClose: onClose, remainingTime: remainingTime },
        React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around w100 h100" },
            React.createElement(Pager, { pageCount: pageCount, page: 0 }, renderPager),
            button)));
};
export var getOfferButton = function (balloonOfferContent, balloonOfferLevelType, onClick) {
    if (balloonOfferLevelType.cost != undefined &&
        balloonOfferContent.balloonOfferTypeId !== IdBalloonOfferTypes.Free) {
        var cost = balloonOfferLevelType.cost;
        var icon = getResourceIconById(cost.resourceId);
        var percentageLocaReplacement = new Map([
            [
                ReplacementLoca.zero_0,
                utilNumber.format((balloonOfferLevelType.discount || 0) * 100),
            ],
        ]);
        return (React.createElement("div", { className: "flex w100" },
            React.createElement("div", { className: "flex flex--end flex__auto" },
                React.createElement(ButtonDefault, { component: ButtonSecondary, amount: balloonOfferLevelType.cost.amount, icon: icon, onClick: onClick })),
            balloonOfferLevelType.discount && (React.createElement("div", { className: "flex flex__full" },
                React.createElement(Icon, { icon: IdIcon.BadgePremiumIcn, styleId: IdStyles.IconExtraLarge },
                    React.createElement("div", { className: "flex flex--stacked flex--guts h100 pb__medium" },
                        React.createElement(TextLoca, { id: IdLoca.value_percentage, className: IdStyles.TextBoldSecondaryOutline, replacements: percentageLocaReplacement })))))));
    }
    return (React.createElement(ButtonPrimary, { onClick: onClick },
        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })));
};
var mapState = function (state) {
    var remainingTime = selectBalloonRemainingTime(state);
    return {
        remainingTime: remainingTime,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.BalloonOffer)); },
    onConsume: function (balloonContentId) { return dispatch(actionBalloonOfferByWithGold(balloonContentId)); },
}); };
export var BalloonOfferDetails = connect(mapState, mapDispatch)(_BalloonOfferDetails);



//////////////////
// WEBPACK FOOTER
// ./src/features/balloon/BalloonOfferDetails.tsx
// module id = 2551
// module chunks = 3